import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserProfileService } from '../services/user.service';
import { Auth } from '../models/auth.models';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  auth: Auth = null;

  constructor(
    private router: Router,
    private user_service: UserProfileService
  ) {
    this.user_service.current_auth.subscribe((res) => {
      this.auth = res;
    });
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.auth != null) {
      return true;
    }
    this.router.navigate(["/account/login"], {
      queryParams: { returnUrl: state.url },
    });
    return false;
  }
}